// extracted by mini-css-extract-plugin
export default {"footer":"UserFooter_footer__a8CWm","footerContainer":"UserFooter_footerContainer__AGS76","footerText":"UserFooter_footerText__pDzyX","footerLink":"UserFooter_footerLink__IqHSh"};